import { render } from "./AnswerPageThree.vue?vue&type=template&id=e3229542&scoped=true"
import script from "./AnswerPageThree.vue?vue&type=script&lang=js"
export * from "./AnswerPageThree.vue?vue&type=script&lang=js"

import "./AnswerPageThree.vue?vue&type=style&index=0&id=e3229542&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3229542"]])

export default __exports__